// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".graphic-comparative-report-container .txt{font-size:14px;margin-bottom:10px;margin-top:20px;color:#51606d}.graphic-comparative-report-container .buttons{display:flex;flex-direction:row-reverse;margin-top:60px;margin-bottom:50px}.graphic-comparative-report-container .buttons #btn-visualize-report{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
